import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  beta: {
    defaultMessage: 'Beta',
    description: 'Small tag label for new features that are in beta testing',
    id: 'WUv7Uo',
  },
});
